import React from "react";
import { useParams, Outlet, Navigate, Routes, Route } from "react-router-dom";
import Footer from "../../components/footer";
import Header from "../../components/header";
import SideBar from "../../components/sidebar/sidebar";
import { TabState } from "./classes.constants";
import MainLayout from "../../layout/Layout";
import Classes from "./classes";

const RootLayout = () => {
  const { id } = useParams();
  const isValidRoute = [
    TabState.Past,
    TabState.Upcoming,
    TabState.Disputed,
    TabState.Close,
  ].includes(id);

  if (!isValidRoute) {
    return <Navigate to={TabState.Upcoming} replace />;
  }

  return (
    <MainLayout>
      <Classes />
    </MainLayout>
  );
};

const Layout = () => {
  return (
    <Routes>
      <Route path="/:id" element={<RootLayout />} />
    </Routes>
  );
};

export default Layout;
